import {
  AiInsight,
  BaseImage,
  DirectDependency,
  EasyFix,
  ExploitIconsGroup,
  Fix,
  IndirectDependency,
  Ingress,
  InternetFacing,
  NodeIndexOutlined,
  PublicImage,
  Runtime,
  SafetyCertificateOutlined,
  ThirdParty
} from "@/icons"
import { InsightsFilter } from "./InsightsFilter"

import type { BaseInsightsFilterProps } from "."

export const META = {
  fromBaseImage: { title: "Base Image", Icon: BaseImage },
  fromThirdParty: { title: "Third Party Image", Icon: ThirdParty },
  isDirect: { title: "Direct Package", Icon: DirectDependency },
  isIndirect: { title: "Indirect Package", Icon: IndirectDependency },
  ingress: { title: "Ingress", Icon: Ingress },
  runtime: { title: "Runtime", Icon: Runtime },
  internetFacing: { title: "Internet Facing", Icon: InternetFacing }
}

const filterMeta = {
  fromBaseImage: META.fromBaseImage,
  isPackageFromBaseImage: META.fromBaseImage,
  fromThirdParty: META.fromThirdParty,
  isThirdParty: META.fromThirdParty,
  isPackageFromThirdParty: META.fromThirdParty,
  isDirect: META.isDirect,
  isPackageDirect: META.isDirect,
  isIndirect: META.isIndirect,
  isPackageInDirect: META.isIndirect,
  hasEasyFix: { title: "Easy Fix", Icon: EasyFix },
  easyFix: { title: "Easy Fix", Icon: EasyFix },
  hasFix: { title: "Has Fix", Icon: Fix },
  ingress: META.ingress,
  isPackageIngress: META.ingress,
  publicImage: { title: "Public Image", Icon: PublicImage },
  runtime: META.runtime,
  isPackageRuntime: META.runtime,
  internetFacing: META.internetFacing,
  isPackageInternetFacing: META.internetFacing,
  poc: { title: "Exploit POC", Icon: ExploitIconsGroup.POC },
  inTheWild: {
    title: "Exploit in the Wild",
    Icon: ExploitIconsGroup.IN_THE_WILD
  },
  isPackageAiRelated: {
    title: "AI Related",
    Icon: AiInsight
  },
  isRoot: {
    title: "Root",
    Icon: NodeIndexOutlined
  },
  hasGuardrails: {
    title: "Has Guardrails",
    Icon: SafetyCertificateOutlined
  }
} as const

export const RiskInsightsFilter = (props: BaseInsightsFilterProps) => {
  return <InsightsFilter filtersMeta={filterMeta} {...props} />
}
